// extracted by mini-css-extract-plugin
module.exports = {"heartButton":"likebutton_heartButton__2hmJB","heartImage":"likebutton_heartImage__1iiYp"};